import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vue",
  "use": "icon-vue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vue\"><path d=\"M615.6 123.6h165.5L512 589.7 242.9 123.6H63.5L512 900.4l448.5-776.9z\" fill=\"#41B883\" p-id=\"2600\" /><path d=\"M781.1 123.6H615.6L512 303 408.4 123.6H242.9L512 589.7z\" fill=\"#34495E\" p-id=\"2601\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol